import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiltroDashboardPostventa from "../Modales/FiltroDashboardPostventa";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import { ExcluirModelosModal } from "./ModelosExcluidosModal";
import { GarantiaCard } from "./GarantiaCard";
import Settings from "@mui/icons-material/Settings";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { MensajeGarantiaModal } from "./MensajeGarantiaModal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AgregarContactoModal from "../Cotizaciones/AgregarContactoModal";
import { GetMonthNameByNumber } from "../../../Finanzas/Helper/GetMonthNameByNumber";
import CommentIcon from '@mui/icons-material/Comment';
import { ModalComentariosTimeline } from "../Cotizaciones/ModalComentariosTimeline";
import ServiciosPendientesChart from "../Mantenimiento/ServiciosPendientesChart";
import FiltroMultiple from "../Modales/FiltroMultiple";
import { ChatScreen } from "../../../Whatsapp/ChatScreen";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { esTelefonoValido } from "../Helpers/esTelefonoValido";
import AgregarContactoGarantias from "../Mantenimiento/AgregarContactoGarantias";
import EditIcon from '@mui/icons-material/Edit';


export const GarantiaMainScreen = () => {
  const history = useHistory();
  const location = useLocation();
  const idselected = location.state?.idselected ?? null;
  const estatus = location.state?.estatus ?? null;
  const [boxstate, setBoxState] = useBox();
  const [openModalContacto, setOpenModalContacto] = useState(false);
  const [cardSelected, setCardSelected] = useState(idselected);
  const [vencimientoGarantias, setVencimientoGarantias] = useState();
  const [clienteSelect, setClienteSelect] = useState();
  const [idGarantia, setIdGarantia] = useState(0);
  const [openModalExcluir, setOpenModalExcluir] = useState(false);
  const [openModalMensajes, setOpenModalMensajes] = useState(false);
  const [titulo, setTitulo] = useState('FIN DE GARANTIA');

  //Modal para cambiar numero
  const [openModal, setOpenModal] = useState(false);
  const [idgarantia, setIdgarantia] = useState();
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState({
    ejercicio_inicio: "",
    ejercicio_fin: "",
    periodo_inicio: "",
    periodo_fin: "",
    tipo: "C",
    whatsapp: boxstate.whatsapp,
    estatus: "",
    sucursales: "",
    adr: "",
  })

  const meses = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
  ];


  const [folioSelect, setFolioSelect] = useState();
  const [openModalComentarios, setOpenModalComentarios] = useState(false);
  const [folioSelected, setFolioSelected] = useState("");
  const [fechaRecordatorio, setFechaRecordatorio] = useState("");

  //whatsapp
  const [modalChat, setModalChat] = useState(false);
  const [telefonoContacto, setTelefonoContacto] = useState("");
  const [cliente, setCliente] = useState("");


  //Totales
  const [totalCotizacion, setTotalCotizacion] = useState(0);

  // filtros en tabla
  const [options, setOptions] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: []
  });

  const [filtros, setFiltros] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: []
  });

  const [filtrosTemp, setFiltrosTemp] = useState({
    estatus: [],
    mensajes: [],
    facturado: [],
    contacto: []
  });

  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [mostrarFiltro, setMostrarFiltro] = useState({
    estatus: false,
    mensajes: false,
    facturado: false,
    contacto: false
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const {
    sucursales,
    adr,
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    filtroSucursales
  } = location.state || {};

  useEffect(() => {

    setBoxState("pv", {
      adr: filtroSucursales.adr,
      sucursal: filtroSucursales.sucursal,
      departamento: filtroSucursales.departamento,
    });
  }, []);

  useEffect(() => {
    // 🔹 Reset filtros aplicados
    setFiltros({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: []
    });

    setFiltrosTemp({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: []
    });

    // 🔹 Reset prioridad
    setPrioridadFiltros([]);

    // 🔹 Cerrar dropdowns de filtros
    setMostrarFiltro({
      estatus: false,
      mensajes: false,
      facturado: false,
      contacto: false
    });
  }, [cardSelected]);


  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros(prev => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades =
        index === -1 ? [...prev, filtro] : prev.slice(0, index + 1);

      // limpiar filtros fuera de prioridad
      setFiltros(prevFiltros => {
        const limpio = { ...prevFiltros };
        Object.keys(limpio).forEach(k => {
          if (!nuevasPrioridades.includes(k)) limpio[k] = [];
        });
        return limpio;
      });

      setFiltrosTemp(prevTemp => {
        const limpio = { ...prevTemp };
        Object.keys(limpio).forEach(k => {
          if (!nuevasPrioridades.includes(k)) limpio[k] = [];
        });
        return limpio;
      });

      return nuevasPrioridades;
    });
  };


  const aplicarFiltros = (data, filtros, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach(filtro => {
      if (filtro === "estatus" && filtros.estatus.length) {
        resultado = resultado.filter(i =>
          filtros.estatus.includes(i.estado)
        );
      }

      if (filtro === "mensajes" && filtros.mensajes.length) {
        resultado = resultado.filter(i =>
          filtros.mensajes.includes(i.mensajes_enviados)
        );
      }

      if (filtro === "facturado" && filtros.facturado.length) {
        resultado = resultado.filter(i =>
          filtros.facturado.includes(i.contrato_adquirido)
        );
      }

      if (filtro === "contacto" && filtros.contacto.length) {
        resultado = resultado.filter(i =>
          filtros.contacto.includes(
            i.contacto !== "N" ? "S" : "N"
          )
        );
      }
    });

    return resultado;
  };

  //Actualizacion de datos dependiendo filtros
  useEffect(() => {
    if (!Array.isArray(vencimientoGarantias)) return;


    let data = getDataByCard(vencimientoGarantias);

    // Aplica filtros según prioridad
    prioridadFiltros.forEach(filtro => {
      if (filtro === "estatus" && filtros.estatus.length > 0) {
        data = data.filter(item =>
          filtros.estatus.includes(item.estado)
        );
      }

      if (filtro === "mensajes" && filtros.mensajes.length > 0) {
        data = data.filter(item =>
          filtros.mensajes.includes(item.mensajes_enviados)
        );
      }

      if (filtro === "facturado" && filtros.facturado.length > 0) {
        data = data.filter(item =>
          filtros.facturado.includes(item.contrato_adquirido)
        );
      }

      if (filtro === "contacto" && filtros.contacto.length > 0) {
        data = data.filter(item =>
          filtros.contacto.includes(
            item.contacto !== "N" ? "S" : "N"
          )
        );
      }
    });

    setDatosFiltrados(data);

    const totalCotizaciones = data.reduce(
      (acc, cotizaciones) => acc + (parseFloat(cotizaciones.total) || 0),
      0
    );

    setTotalCotizacion(totalCotizaciones);

  }, [vencimientoGarantias, filtros, prioridadFiltros, cardSelected]);

  const getDataByCard = (data) => {
    if (!Array.isArray(data)) return [];

    switch (cardSelected) {
      case 2:
        return data.filter(g => g.grupo === "TMP");
      case 3:
        return data.filter(g => g.grupo === "TRD");
      case 4:
        return data.filter(g => g.grupo === "FIN");
      case 1:
      default:
        return data;
    }
  };


  //Esquema de filtrado en tabla
  useEffect(() => {
    if (!Array.isArray(vencimientoGarantias)) return;

    const dataBase = getDataByCard(vencimientoGarantias);

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      if (index === -1) {
        return aplicarFiltros(
          dataBase,
          filtros,
          prioridadFiltros
        );
      }

      if (index === 0) return dataBase;

      return aplicarFiltros(
        dataBase,
        filtros,
        prioridadFiltros.slice(0, index)
      );
    };

    setOptions({
      estatus: [...new Set(getBaseData("estatus").map(i => i.estado))]
        .map(v => ({ value: v, label: v })),

      mensajes: [...new Set(getBaseData("mensajes").map(i => i.mensajes_enviados))]
        .map(v => ({
          value: v,
          label:
            v === 0 ? "Pendiente" :
              v === 1 ? "Recordatorio 1" :
                v === 2 ? "Recordatorio 2" :
                  v === 3 ? "Recordatorio 3" :
                    "Desconocido"
        })),

      facturado: [...new Set(getBaseData("facturado").map(i => i.contrato_adquirido))]
        .map(v => ({ value: v, label: v === "S" ? "Sí" : "No" })),

      contacto: (() => {
        const base = getBaseData("contacto");
        return [
          ...(base.some(i => i.contacto !== "N") ? [{ value: "S", label: "Sí" }] : []),
          ...(base.some(i => i.contacto === "N") ? [{ value: "N", label: "No" }] : [])
        ];
      })()
    });

  }, [vencimientoGarantias, filtros, prioridadFiltros, cardSelected]);

  const limpiarFiltros = () => {
    setFiltros({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: [],
    });

    setFiltrosTemp({
      estatus: [],
      mensajes: [],
      facturado: [],
      contacto: [],
    });

    setPrioridadFiltros([]);
    setDatosFiltrados([]);
  };


  const handleOpenModalExcluir = () => {
    setOpenModalExcluir(true);
  };

  const handleCloseModalExcluir = () => {
    setOpenModalExcluir(false);
  };

  const handleOpenModalMensajes = () => {
    setOpenModalMensajes(true);
  };

  const handleCloseModalMensajes = () => {
    setOpenModalMensajes(false);
  };

  const handleOpenModalContacto = (idcliente, idGarantia) => {
    // if (!idcliente) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Cliente no registrado",
    //     text: "No se puede ingresar el contacto de un cliente no registrado.",
    //     confirmButtonText: "Entendido",
    //   });
    //   return;
    // }
    setClienteSelect(idcliente);
    setIdGarantia(idGarantia)
    setOpenModalContacto(true);
  };
  const handleCloseModalContacto = () => {
    setOpenModalContacto(false);
    setClienteSelect("");
  };

  const currentDate = new Date();
  const anioActual = currentDate.getFullYear();
  const mesActual = currentDate.getMonth() + 1;
  useEffect(() => {
    if (openModalContacto === true || openModalExcluir === true)
      return;
    onIniciar(
      ejercicio_inicio,
      ejercicio_fin,
      periodo_inicio,
      periodo_fin,
      'C',
      boxstate.whatsapp,
      estatus,
      sucursales,
      adr,
      estatus
    );
    setFiltrosSeleccionados({
      ...filtrosSeleccionados,
      ejercicio_inicio: ejercicio_inicio,
      ejercicio_fin: ejercicio_fin,
      periodo_inicio: periodo_inicio,
      periodo_fin: periodo_fin,
      tipo: "C",
      whatsapp: boxstate.whatsapp,
      estatus: estatus,
      sucursales: sucursales,
      adr: adr,
    })
  }, [openModalExcluir, openModalContacto]);

  const onUpdate = () => {

    onIniciar(
      ejercicio_inicio,
      ejercicio_fin,
      periodo_inicio,
      periodo_fin,
      'C',
      boxstate.whatsapp,
      estatus,
      sucursales,
      adr
    );
  }

  const onIniciar = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    facturado,
    whatsapp,
    estatus,
    filtroSucursales,
    filtoAdr
  ) => {
    setLoader({ ...loader, mostrar: true });
    var sucursalesEnviar = filtroSucursales;
    var adrEnviar = filtoAdr;

    var p_fin = "";
    if (filtroSucursales === undefined || filtroSucursales === null || filtroSucursales === "") {
      sucursalesEnviar = "0";
    }
    if (filtoAdr === undefined || filtoAdr === null || filtoAdr === "") {
      adrEnviar = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (Number(p_fin) < Number(periodo_inicio) && Number(ejercicio_fin) < Number(ejercicio_inicio)) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning"
      );
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/VencimientosGarantias?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&facturado=${facturado}&whatsapp=${whatsapp}&estado=${estatus}&adr=${adrEnviar}&sucursal=${sucursalesEnviar}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setVencimientoGarantias(result);

          // const mesInicio = GetMonthNameByNumber(periodo_inicio).toUpperCase();
          // const mesFin = GetMonthNameByNumber(periodo_fin).toUpperCase();

          // const tituloPeriodo = periodo_inicio === periodo_fin
          //   ? `${mesInicio} ${ejercicio}`
          //   : `${mesInicio} - ${mesFin} ${ejercicio}`;

          const mesInicio = meses[periodo_inicio - 1];
          const mesFin = meses[p_fin - 1];

          let tituloP = "FIN DE GARANTIA ";

          // 1️⃣ Mes diferente y ejercicio diferente
          if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
          }
          // 2️⃣ Mismo mes y ejercicio diferente
          else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
          }
          // 3️⃣ Mes diferente y mismo ejercicio
          else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
            tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
          }
          // 4️⃣ Mismo mes y mismo ejercicio
          else {
            tituloP += `${mesInicio} - ${ejercicio_inicio}`;
          }

          setTitulo(tituloP);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  }

  const handleOpenModal = (idRegistro) => {
    setIdgarantia(idRegistro);
    // console.log(idRegistro)
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setIdgarantia(0);
    setOpenModal(false);
  };

  const onExecute = (
    ejercicio_inicio,
    ejercicio_fin,
    periodo_inicio,
    periodo_fin,
    facturado,
    whatsapp,
    estatus
  ) => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    var p_fin = "";
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (
      periodo_fin === undefined ||
      periodo_fin === null ||
      periodo_fin === "" ||
      periodo_fin === "0"
    ) {
      p_fin = periodo_inicio;
    } else {
      p_fin = periodo_fin;
    }

    if (Number(p_fin) < Number(periodo_inicio) && Number(ejercicio_fin) < Number(ejercicio_inicio)) {
      Swal.fire(
        "DASHBOARD",
        "La fecha de inicio no puede ser menor a la final",
        "warning"
      );
      return;
    }

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DashboardPostventa/VencimientosGarantias?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${p_fin}&facturado=${facturado}&whatsapp=${whatsapp}&estado=${estatus}&adr=${adr}&sucursal=${sucursales}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setVencimientoGarantias(result);
          const mesInicio = meses[periodo_inicio - 1];
          const mesFin = meses[p_fin - 1];

          let tituloP = "FIN DE GARANTIA ";

          // 1️⃣ Mes diferente y ejercicio diferente
          if (mesInicio !== mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${mesFin} ${ejercicio_fin}`;
          }
          // 2️⃣ Mismo mes y ejercicio diferente
          else if (mesInicio === mesFin && ejercicio_inicio !== ejercicio_fin) {
            tituloP += `${mesInicio} ${ejercicio_inicio} - ${ejercicio_fin}`;
          }
          // 3️⃣ Mes diferente y mismo ejercicio
          else if (mesInicio !== mesFin && ejercicio_inicio === ejercicio_fin) {
            tituloP += `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
          }
          // 4️⃣ Mismo mes y mismo ejercicio
          else {
            tituloP += `${mesInicio} - ${ejercicio_inicio}`;
          }

          setTitulo(tituloP);

          limpiarFiltros();
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const totalGarantias = vencimientoGarantias?.length;
  const temprana = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "TMP"
  );
  const totalTemprana = temprana?.length;
  const tardia = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "TRD"
  );
  const totalTardia = tardia?.length;
  const checklist = vencimientoGarantias?.filter(
    (garantia) => garantia.grupo === "FIN"
  );
  const totalChecklist = checklist?.length;

  const getGarantiasFiltradas = () => {
    if (!datosFiltrados) return [];

    switch (cardSelected) {
      case 1:
        return datosFiltrados; // Todo
      case 2:
        return datosFiltrados.filter(
          (garantia) => garantia.grupo === "TMP"
        ); // Temprana
      case 3:
        return datosFiltrados.filter(
          (garantia) => garantia.grupo === "TRD"
        ); // Tardía
      case 4:
        return datosFiltrados.filter(
          (garantia) => garantia.grupo === "FIN"
        ); // Checklist (solo si grupo === 'Checklist')
      default:
        return datosFiltrados;
    }
  };

  const onConfiguracionGarantia = () => {
    history.push("/PostVenta/ConfigurarMontos");
  };

  const agrupado = () => {
    const data = getGarantiasFiltradas();

    return [
      { titulo: "PowerWard Venta Temprana", grupo: "TMP" },
      { titulo: "PowerWard Venta Tardía", grupo: "TRD" },
      { titulo: "Fin de Garantia", grupo: "FIN" },
    ]
      .map(({ titulo, grupo }) => ({
        titulo,
        registros: data.filter((item) => item.grupo === grupo),
      }))
      .filter((g) => g.registros.length > 0); // Solo mostrar los grupos con registros
  };
  const onRegresar = () => {
    history.push("Dashboard", {
      sucursales,
      adr,
      ejercicio_inicio,
      ejercicio_fin,
      periodo_inicio,
      periodo_fin,
      filtroSucursales,
      regresar: true
    });
  };

  const handleOpenModalComentarios = (folio, fecha) => {
    setFolioSelected(folio);
    setFechaRecordatorio(fecha)
    setOpenModalComentarios(true);
  };

  const handleCloseModalComentarios = () => {
    setOpenModalComentarios(false);
    // if (actualizarLista) actualizarLista();
  };

  //chat de whatsapp
  const handleOpenModalChat = (numero, cliente) => {
    setTelefonoContacto(numero);
    setCliente(cliente);
    setModalChat(true);
  };

  const handleCloseModalChat = () => {
    setTelefonoContacto("");
    setCliente("");
    setModalChat(false);
  };

  const calcularTotalesGrupo = (registros) => {
    return {
      totalRegistros: registros.length,
      totalFacturados: registros.filter(r => r.facturado === "S").length,
      totalMensajes: registros.reduce(
        (acc, r) => acc + (Number(r.mensajes_enviados) || 0),
        0
      ),
      totalTotal: registros.reduce(
        (acc, r) => acc + (Number(r.total) || 0),
        0
      ),
    };
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className={"garantia-main-screen"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />
      <AgregarContactoModal
        open={openModalContacto}
        onClose={handleCloseModalContacto}
        idcliente={clienteSelect}
        idGarantia={idGarantia}
      />
      <div className="garantia-actions">
        <div
          className="garantia-actions-regresar"
          onClick={() => onRegresar()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="buttons">
          <button
            className="garantia-header-configuracion"
            onClick={() => onConfiguracionGarantia()}
          >
            <Settings /> Configuracion
          </button>
          {/* <button
            className="garantia-header-mensajes"
            onClick={() => handleOpenModalMensajes()}
          >
            <WhatsAppIcon /> Mensajes
          </button> */}
          <button
            className="garantia-header-excluir"
            onClick={() => handleOpenModalExcluir()}
          >
            <DoNotDisturbIcon /> Reglas de Exclusión
          </button>
        </div>
        <div className="garantia-actions-filtro">
          <FiltroDashboardPostventa
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            mostrarestatus={true}
            mostrarwhatsapp={true}
            mostrarfacturado={true}
            ejercicio_inicio={ejercicio_inicio}
            ejercicio_fin={ejercicio_fin}
            periodo_inicio={periodo_inicio}
            periodo_fin={periodo_fin}
            sucursalesEncontrados={sucursales}
            adrEncontrados={adr}
            filtroSucursales={filtroSucursales}
            setFiltrosSeleccionados={setFiltrosSeleccionados}
          />
        </div>
      </div>
      {vencimientoGarantias && vencimientoGarantias.length > 0 && (
        <>
          <div className="contador-garantia-encontrados">
            {/* Garantias encontradas: {vencimientoGarantias.length} */}
          </div>
          <div className="garantia">
            <div className="garantia-flex">
              <div className="detalle-clientes-gestionar-container-resumen">
                <GarantiaCard
                  titulo={"TOTAL"}
                  cantidad={totalGarantias}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 1);
                    setCardSelected(1);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 1 ? true : false}
                />
                <GarantiaCard
                  titulo={"VNT TEMPRANA"}
                  cantidad={totalTemprana}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 1);
                    setCardSelected(2);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 2 ? true : false}
                />
                <GarantiaCard
                  titulo={"VENTA TARDIA"}
                  cantidad={totalTardia}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 2);
                    setCardSelected(3);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 3 ? true : false}
                />
                <GarantiaCard
                  titulo={"CHECKLIST"}
                  cantidad={totalChecklist}
                  className={
                    "detalle-clientes-gestionar-container-resumen-item-click"
                  }
                  onClick={() => {
                    // onExecuteCards(state.idcliente, 4);
                    setCardSelected(4);
                  }}
                  porcentaje={"100%"}
                  activo={cardSelected === 4 ? true : false}
                />
              </div>
              <div className="garantia-container scroll">
                <table cellPadding={0} cellSpacing={0}>
                  <thead>
                    <tr>
                      <th className="sticky-chat-whatsapp"></th>
                      <th className="sticky-folio">Serie</th>
                      <th >
                        <div>Cliente</div>
                      </th>
                      <th>
                        <div>Sucursal</div>
                      </th>
                      <th>
                        <div>Modelo</div>
                      </th>
                      <th>
                        <div>Responsable</div>
                      </th>
                      <th>
                        <div>Fecha Envio</div>
                      </th>
                      {/* <th>
                        <div>Monto</div>
                      </th> */}
                      <th>
                        <FiltroMultiple
                          label="Contacto"
                          field="contacto"
                          options={options.contacto}
                          filtros={filtros}
                          setFiltros={setFiltros}
                          filtrosTemp={filtrosTemp}
                          setFiltrosTemp={setFiltrosTemp}
                          mostrarFiltro={mostrarFiltro}
                          setMostrarFiltro={setMostrarFiltro}
                          actualizarPrioridad={actualizarPrioridad}
                          setPrioridadFiltros={setPrioridadFiltros}

                        />
                      </th>
                      <th>
                        <FiltroMultiple
                          label="Estatus"
                          field="estatus"
                          options={options.estatus}
                          filtros={filtros}
                          setFiltros={setFiltros}
                          filtrosTemp={filtrosTemp}
                          setFiltrosTemp={setFiltrosTemp}
                          mostrarFiltro={mostrarFiltro}
                          setMostrarFiltro={setMostrarFiltro}
                          actualizarPrioridad={actualizarPrioridad}
                          setPrioridadFiltros={setPrioridadFiltros}
                        />
                      </th>
                      <th>
                        <FiltroMultiple
                          label="Mensaje"
                          field="mensajes"
                          options={options.mensajes}
                          filtros={filtros}
                          setFiltros={setFiltros}
                          filtrosTemp={filtrosTemp}
                          setFiltrosTemp={setFiltrosTemp}
                          mostrarFiltro={mostrarFiltro}
                          setMostrarFiltro={setMostrarFiltro}
                          actualizarPrioridad={actualizarPrioridad}
                          setPrioridadFiltros={setPrioridadFiltros}
                          transformValue={Number}
                        />
                      </th>
                      <th>
                        <FiltroMultiple
                          label="Facturado"
                          field="facturado"
                          options={options.facturado}
                          filtros={filtros}
                          setFiltros={setFiltros}
                          filtrosTemp={filtrosTemp}
                          setFiltrosTemp={setFiltrosTemp}
                          mostrarFiltro={mostrarFiltro}
                          setMostrarFiltro={setMostrarFiltro}
                          actualizarPrioridad={actualizarPrioridad}
                          setPrioridadFiltros={setPrioridadFiltros}

                        />
                      </th>
                      <th>
                        <div>Comentarios</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {agrupado().map((grupo, i) => {
                      const totales = calcularTotalesGrupo(grupo.registros);

                      return (
                        <React.Fragment key={i}>
                          <tr className="grupo-row">
                            <td colSpan={12} className="grupo-header">
                              {grupo.titulo}
                            </td>
                          </tr>
                          {grupo.registros.map((item, index) => (
                            <tr key={index}>
                              <td className="sticky-chat-whatsapp">
                                <div
                                  className={
                                    esTelefonoValido(item.contacto)
                                      ? "boton-chat-whatsapp"
                                      : "boton-chat-whatsapp-sin-numero"
                                  }
                                  onClick={
                                    esTelefonoValido(item.contacto)
                                      ? () =>
                                        handleOpenModalChat(item.contacto, item.razon_social)
                                      : undefined
                                  }
                                >
                                  <WhatsAppIcon />
                                </div>
                              </td>
                              <td className="sticky-folio">{item.num_serie}</td>
                              <td className="celda-cliente">{item.razon_social}</td>
                              <td className="celda-sucursal">
                                {capitalizePalabras(item.sucursal)}
                              </td>
                              <td>{item.modelo}</td>
                              <td className="celda-cliente">{item.responsable}</td>
                              <td className="ta-center">
                                {item.expiracion_format}
                              </td>
                              {/* <td className="celda-whatsapp ta-center">
                                <div className="whatsapp">
                                  {item.contacto === "N" ? (
                                    <div
                                      className="boton-agregar-contacto"
                                      onClick={() =>
                                        handleOpenModalContacto(item.idcliente, item.id_garantia)
                                      }
                                    >
                                      <AddCircleOutlineIcon /> Agregar
                                    </div>
                                  ) : (
                                    <>{item.contacto}</>
                                  )}
                                </div>
                              </td> */}

                              <td className="celda-whatsapp ta-center">
                                <div className="whatsapp">
                                  {item.contacto === "N" ? (
                                    <div
                                      className="boton-agregar-contacto"
                                      onClick={() => handleOpenModal(item.id_garantia)}
                                    >
                                      <AddCircleOutlineIcon /> Agregar
                                    </div>
                                  ) : (
                                    <div
                                      className={
                                        esTelefonoValido(item.contacto)
                                          ? "editar-numero"
                                          : "editar-numero-error"
                                      }
                                    >
                                      {item.contacto}
                                      <span>
                                        <EditIcon
                                          style={{ cursor: "pointer", fontSize: 16, marginLeft: "5px" }}
                                          onClick={() => handleOpenModal(item.id_garantia)}
                                        />
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </td>


                              <td>{item.estado}</td>
                              <td className="ta-center">
                                {/* {item.mensaje_enviado === "S" ? (
                                <CheckCircleIcon
                                  sx={{ color: "#5aa05b !important" }}
                                />
                              ) : (
                                <RemoveCircleIcon
                                  sx={{ color: "#7b7b7b !important" }}
                                />
                              )} */}
                                {item.mensajes_enviados}
                              </td>
                              <td className="ta-center">
                                {item.contrato_adquirido === "S" ? (
                                  <CheckCircleIcon
                                    sx={{ color: "#5aa05b !important" }}
                                  />
                                ) : (
                                  <RemoveCircleIcon
                                    sx={{ color: "#7b7b7b !important" }}
                                  />
                                )}
                              </td>
                              <td className="celda-comentario">
                                <div className="contenido-flex">
                                  <div
                                    // className={`boton-detalle-cotizaciones ${puedeEditar ? "" : "inhabilitado"}`}
                                    onClick={() => handleOpenModalComentarios(item.id_garantia, item.expiracion_format)}
                                  >
                                    <CommentIcon />
                                  </div>
                                  <span className="comentario-texto">
                                    <label>{item.comentario}</label>
                                    <br />
                                    {item.creador_comentario && (
                                      <span>
                                        Creado por: {item.creador_comentario} - el{" "}
                                        {item.fecha_comentario}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {/* 🔹 FILA TOTAL DEL GRUPO */}
                          <tr className="tfoot">
                            <td colSpan={4} className="ta-center fw-bold">
                              {"Total: "}
                            </td>
                            <td className="ta-center fw-bold">
                              {/* {totales.totalTotal} */}
                            </td>
                            <td colSpan={2} className="ta-right fw-bold">
                              Registros:
                              {/* {grupo.grupo} */}
                            </td>

                            <td className="ta-center fw-bold">
                              {totales.totalRegistros}
                            </td>

                            <td className="ta-center fw-bold">
                              {/* {totales.totalMensajes} */}
                            </td>

                            <td className="ta-center fw-bold">
                              {/* {totales.totalFacturados} */}
                            </td>

                            <td colSpan={2}></td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}

      <AgregarContactoGarantias
        open={openModal}
        onClose={handleCloseModal}
        idgarantia={idgarantia}
        update={onExecute}
        filtrosSeleccionados={filtrosSeleccionados}
      />

      <ExcluirModelosModal
        open={openModalExcluir}
        onClose={handleCloseModalExcluir}
      />
      <MensajeGarantiaModal
        open={openModalMensajes}
        onClose={handleCloseModalMensajes}
        tipoGarantia={"TMP"}
      />
      <ModalComentariosTimeline
        open={openModalComentarios}
        onClose={handleCloseModalComentarios}
        folio={folioSelected}
        fecha={fechaRecordatorio}
        tipo={"GE"}
        update={onUpdate}
      />
      <ChatScreen
        open={modalChat}
        onClose={handleCloseModalChat}
        numeroTelefono={telefonoContacto}
        cliente={cliente}
        modulo={"POSVENTA"}
      />
    </PlantillaScreen>
  );
};
